import { useEffect, useState } from 'react';
import { Collection } from '@common/merch';

const SCROLL_OFFSET = 200;

export const useActiveCategoryTracking = (collections: Collection[]) => {
  const [activeCollection, setActiveCollection] = useState<string | null>(null);

  useEffect(() => {
    const handleScroll = () => {
      if (collections.length === 0) return;

      const scrollPosition = window.scrollY + SCROLL_OFFSET;

      for (let i = collections.length - 1; i >= 0; i--) {
        const element = document.getElementById(`collection-${collections[i].id}`);
        if (element && scrollPosition >= element.offsetTop) {
          setActiveCollection(collections[i].id);
          break;
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, [collections]);

  return activeCollection;
};
